document.addEventListener('DOMContentLoaded', () => {
  const quickTagsWrapper = document.querySelector('.collection-quick-tags');

  const updateScrollEndState = (rail) => {
    if (!rail) return;

    const hasOverflow = rail.scrollWidth > rail.clientWidth + 2;
    const atEnd = !hasOverflow || rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    rail.classList.toggle('is-scroll-end', atEnd);
  };

  if (quickTagsWrapper) {
    const updateQuickTagsScrollEnd = () => updateScrollEndState(quickTagsWrapper);

    updateQuickTagsScrollEnd();
    window.requestAnimationFrame(updateQuickTagsScrollEnd);
    quickTagsWrapper.addEventListener('scroll', updateQuickTagsScrollEnd, { passive: true });
    window.addEventListener('resize', updateQuickTagsScrollEnd);
    window.addEventListener('load', updateQuickTagsScrollEnd);
  }

  const drawer = document.getElementById('FacetsDrawer');
  if (!drawer) return;

  const panel = drawer.querySelector('.facets-drawer__panel');
  const OPEN_PARAM = 'open_facets';

  const getAllQuickTagLink = () => {
    if (!quickTagsWrapper) return null;
    return quickTagsWrapper.querySelector('[data-quick-tag-all]');
  };

  const hasActiveFilteredQuickTag = () => {
    if (!quickTagsWrapper) return false;
    const activeTag = quickTagsWrapper.querySelector('[data-quick-tag].is-active');
    if (!activeTag) return false;
    return !activeTag.hasAttribute('data-quick-tag-all');
  };

  const clearThemeBlur = () => {
    const targets = [
      document.documentElement,
      document.body,
      document.getElementById('main-content'),
      document.getElementById('nav-wrapper'),
      document.querySelector('main'),
      document.querySelector('.header'),
      document.querySelector('.grid-archive'),
      document.querySelector('.grid-archive__outer-container'),
      document.querySelector('.grid-archive__main-container'),
      document.querySelector('.grid-archive__content')
    ].filter(Boolean);

    targets.forEach((el) => {
      el.style.filter = 'none';
      el.style.webkitFilter = 'none';
      el.style.backdropFilter = 'none';
      el.style.webkitBackdropFilter = 'none';
      el.style.opacity = '';
    });

    document.querySelectorAll('[class*="overlay"], [class*="backdrop"]').forEach((el) => {
      if (el === drawer || drawer.contains(el)) return;
      el.style.filter = 'none';
      el.style.webkitFilter = 'none';
      el.style.backdropFilter = 'none';
      el.style.webkitBackdropFilter = 'none';
    });
  };

  const resetInlineThemeBlur = () => {
    const targets = [
      document.documentElement,
      document.body,
      document.getElementById('main-content'),
      document.getElementById('nav-wrapper'),
      document.querySelector('main'),
      document.querySelector('.header'),
      document.querySelector('.grid-archive'),
      document.querySelector('.grid-archive__outer-container'),
      document.querySelector('.grid-archive__main-container'),
      document.querySelector('.grid-archive__content')
    ].filter(Boolean);

    targets.forEach((el) => {
      el.style.filter = '';
      el.style.webkitFilter = '';
      el.style.backdropFilter = '';
      el.style.webkitBackdropFilter = '';
    });
  };

  const lockScroll = () => {
    document.documentElement.classList.add('facets-drawer-open');
    document.body.classList.add('facets-drawer-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    clearThemeBlur();
  };

  const unlockScroll = () => {
    document.documentElement.classList.remove('facets-drawer-open');
    document.body.classList.remove('facets-drawer-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.pointerEvents = '';
    resetInlineThemeBlur();
  };

  const openDrawer = () => {
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    lockScroll();
    clearThemeBlur();
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockScroll();
    clearThemeBlur();

    window.setTimeout(() => {
      if (!drawer.classList.contains('is-open')) {
        drawer.hidden = true;
        clearThemeBlur();
      }
    }, 320);
  };

  const syncSortButtons = (wrapper, activeValue) => {
    if (!wrapper) return;

    wrapper.querySelectorAll('[data-sort-button]').forEach((button) => {
      const isActive = button.getAttribute('data-sort-value') === activeValue;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const buildReloadUrlForDrawer = () => {
    const allLink = getAllQuickTagLink();

    if (hasActiveFilteredQuickTag() && allLink) {
      const resetUrl = new URL(allLink.href, window.location.origin);
      resetUrl.searchParams.set(OPEN_PARAM, '1');
      return resetUrl.toString();
    }

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set(OPEN_PARAM, '1');
    return currentUrl.toString();
  };

  const maybeOpenAfterReload = () => {
    const url = new URL(window.location.href);
    if (url.searchParams.get(OPEN_PARAM) !== '1') return;

    url.searchParams.delete(OPEN_PARAM);
    window.history.replaceState({}, '', url.toString());

    openDrawer();
  };

  drawer.hidden = true;
  drawer.setAttribute('aria-hidden', 'true');
  unlockScroll();
  clearThemeBlur();
  maybeOpenAfterReload();

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('.toggle-filtering');
    const closeTrigger = event.target.closest('[data-facets-close]');
    const sortButton = event.target.closest('[data-sort-button]');

    if (openTrigger) {
      event.preventDefault();
      window.location.assign(buildReloadUrlForDrawer());
      return;
    }

    if (closeTrigger) {
      event.preventDefault();
      event.stopPropagation();
      closeDrawer();
      return;
    }

    if (sortButton) {
      event.preventDefault();

      const wrapper = sortButton.closest('.sort-by--buttons');
      if (!wrapper) return;

      const select = wrapper.querySelector('#SortByMobile');
      if (!select) return;

      const form = select.closest('form');
      const value = sortButton.getAttribute('data-sort-value');
      if (!value) return;

      select.value = value;
      syncSortButtons(wrapper, value);

      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.dispatchEvent(new Event('input', { bubbles: true }));

      if (form) {
        form.dispatchEvent(new Event('input', { bubbles: true }));
      }

      return;
    }

    if (
      drawer.classList.contains('is-open') &&
      panel &&
      !panel.contains(event.target)
    ) {
      closeDrawer();
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('#SortByMobile');
    if (!select) return;

    const wrapper = select.closest('.sort-by--buttons');
    if (!wrapper) return;

    syncSortButtons(wrapper, select.value);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  window.addEventListener('pageshow', () => {
    unlockScroll();
    clearThemeBlur();
    maybeOpenAfterReload();
  });
});




//HAUTEUR CARTE COLLECTION//
document.addEventListener('DOMContentLoaded', () => {
  const applyMobileBannerHeights = () => {
    if (window.innerWidth > 749) {
      document.querySelectorAll('.grid-archive__content .banner .banner__wrapper').forEach((wrapper) => {
        wrapper.style.height = '';
      });
      return;
    }

    const grid = document.querySelector('.grid-archive__content');
    if (!grid) return;

    const firstProductCard = grid.querySelector('.card.card--product');
    if (!firstProductCard) return;

    const productRect = firstProductCard.getBoundingClientRect();
    const productHeight = Math.round(productRect.height);

    if (!productHeight || productHeight < 50) return;

    const largeBannerWrapper = grid.querySelector('.banner.banner--large .banner__wrapper');
    const smallBannerWrappers = grid.querySelectorAll('.banner.banner--small .banner__wrapper');

    if (largeBannerWrapper) {
      largeBannerWrapper.style.height = `${Math.round(productHeight * 0.82)}px`;
    }

    smallBannerWrappers.forEach((wrapper) => {
      wrapper.style.height = `${productHeight}px`;
    });
  };

  const debounce = (fn, delay = 120) => {
    let timer;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  };

  const run = debounce(applyMobileBannerHeights, 120);

  applyMobileBannerHeights();
  window.addEventListener('resize', run);
  window.addEventListener('load', applyMobileBannerHeights);

  const observer = new MutationObserver(run);
  const grid = document.querySelector('.grid-archive__content');
  if (grid) {
    observer.observe(grid, { childList: true, subtree: true });
  }
});
